namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemDt2Columns {
        static columnsKey = 'AdvPromo.Adv05ItemDt';
    }
}
